<!--suppress ALL -->
<template>
    <div :class="$style.container"
         v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)">


        <div :class="$style.title" style="padding-top: 1rem;">
            <div :class="$style.left">
                服务商管理
                <el-button type="success" size="mini" @click.stop="handleAddService"
                           icon="el-icon-plus" style="float: right;padding-left: 1rem">
                    添加服务商
                </el-button>
                <div style="height: 45px;padding-top:8px;padding-bottom:5px; margin-top: 15px">
                    <el-input
                            placeholder="输入关键字进行过滤"
                            v-model="filterText">
                    </el-input>
                </div>
                <el-scrollbar :class="$style.scrollbar">

                    <el-tree
                            class="filter-tree"
                            :data="treeNodes"
                            :props="defaultProps"
                            default-expand-all
                            :filter-node-method="filterNode"
                            @node-click="handleNodeClick"

                            ref="tree">
                                <span class="custom-tree-node" slot-scope="{ node, data }">
                        <img :src="iconz" width="16px" style="margin-right: 5px;vertical-align: middle">
                                <span>{{ node.label}}</span>
                           </span>
                    </el-tree>

                </el-scrollbar>
            </div>

            <div :class="$style.right" style="min-width:30%">
                <div :class="$style.header" style="font-size: 20px; margin-top: 5px">
                    <span>ServiceOne</span>
                    <el-button type="primary" size="mini" @click.stop="saveAction"
                               style="float: right; margin-top: -5px">
                        保存
                    </el-button>
                    <el-button size="mini" type="danger" style="float: right; margin-top: -5px; margin-right: 10px"
                               @click.stop="backAction">
                        <img :src="backArrow" width="10px" style="margin-right: 5px;">返回
                    </el-button>
                </div>
                <div style="width: 100%; height: 0px; margin-top: -5px;border:1px dashed gainsboro"></div>


                <el-form ref="form" :model="form" label-width="100px" style="margin-top: 20px">

                    <el-form-item label="零企服务商ID" v-if="form.provider_id != ''">
                        <el-select v-model="form.linked_tenant" clearable filterable placeholder="请选择省份"
                                   style="width: 100%" v-on:change="getFormInfo()">
                            <el-option
                                    v-for="item in treeNodes"
                                    :key="item.linked_tenant"
                                    :label="item.linked_tenant"
                                    :value="item.linked_tenant">
                                <span style="float: left">{{ item.linked_tenant }}</span>
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="零企服务商ID" v-if="form.provider_id == ''">
                        <el-input v-model="form.linked_tenant" disabled></el-input>
                    </el-form-item>

                    <el-form-item label="名称">
                        <el-input v-model="form.provider_name"></el-input>
                    </el-form-item>

                    <el-form-item label="地址">
                        <el-input v-model="form.address"></el-input>
                    </el-form-item>

                    <el-form-item label="联系电话">
                        <el-input v-model="form.telephone"></el-input>
                    </el-form-item>

                    <el-form-item label="公司邮箱">
                        <el-input v-model="form.e_mail"></el-input>
                    </el-form-item>
                    <el-form-item label="覆盖省份">
                        <el-select v-model="form.province_id" clearable filterable placeholder="请选择省份"
                                   style="width: 100%" v-on:change="getCityList(true)">
                            <el-option
                                    v-for="item in provinceArray"
                                    :key="item.province_id"
                                    :label="item.province_name"
                                    :value="item.province_id">
                                <span style="float: left">{{ item.province_name }}</span>
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="覆盖城市">
                        <el-select v-model="form.city_id" clearable filterable placeholder="请选择城市"
                                   style="width: 100%">
                            <el-option
                                    v-for="item in cityArray"
                                    :key="item.city_id"
                                    :label="item.city_name"
                                    :value="item.city_id">
                                <span style="float: left">{{ item.city_name }}</span>
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="覆盖门店">
                        <el-select v-model="form.store_id" clearable multiple filterable placeholder="请选择城市"
                                   style="width: 100%">
                            <el-option
                                    v-for="item in storeArray"
                                    :key="item.store_id"
                                    :label="item.store_name"
                                    :value="item.store_id">
                                <span style="float: left">{{ item.store_name }}</span>
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="启用"> <!-- v-if="form.status != 'AWAIT'"-->
                        <el-switch v-model="form.status_b" active-color="#13ce66"></el-switch>
                    </el-form-item>


                </el-form>

            </div>
        </div>

        <el-dialog
                :visible.sync="dialogVisible" :show-close="false"
                width="50%" :class="$style.modal" class="a_modal"
                :before-close="handleClose">
            <div slot="title" :class="$style.title">
                <span style="color: cornflowerblue; font-size: 18px">对接 [零企服务商]</span>
                <div>
                    <!--<el-button type="success" size="small" :disabled="isSave" @click.stop="sendServicejoinWork">确定-->
                    <!--</el-button>-->
                    <el-button type="danger" size="small" @click.stop="dialogVisible = false">取消</el-button>
                </div>
            </div>

            <div>
                <el-form :model="form2" label-width="100px" class="c_form">
                    <el-form-item label="服务商ID">
                        <el-input
                                placeholder="请输入零企服务商ID" style="width: 82%"
                                prefix-icon="el-icon-search"
                                v-model="form2.code">
                        </el-input>
                        <el-button type="primary" @click.stop="getFindServiceProvider">查询</el-button>
                    </el-form-item>
                </el-form>

                <div :class="$style.content" v-if="searchResult">
                    <div :class="$style.top">
                        <img src="../../../assets/images/visiting.svg"/>
                        <div :class="$style.right">
                            <h4>{{form2.tenant_name}}</h4>
                            <p>{{form2.comments}}</p>
                        </div>
                    </div>
                    <div :class="$style.bottom" @click.stop="showWorkerInfo">
                        查看详情
                    </div>
                </div>
                <p :class="$style.noData" v-if="nodata">没有找到相关信息</p>
                <div>

                </div>
            </div>
        </el-dialog>

        <el-dialog
                :visible.sync="showInfo" :show-close="false"
                width="750px" :class="$style.modal" class="a_modal"
                :before-close="handleClose">
            <div slot="title" :class="$style.title">
                <span style="color: cornflowerblue; font-size: 18px">对接 [零企服务商]</span>
                <div>
                    <el-button type="warning" size="small" @click.stop="join365Action">发送对接请求</el-button>
                    <el-button type="danger" size="small" @click.stop="backJoin365">返回</el-button>
                </div>
            </div>
            <div style="width: 100%; height: 0px; margin-top: -10px;border:1px dashed gainsboro"></div>


            <div style="margin-top: 20px">
                <el-form ref="form2" :model="form2" label-width="15%">

                    <el-form-item label="公司名称">
                        <span style="width:90%;color: dodgerblue">{{form2.tenant_name}}</span>
                    </el-form-item>
                    <el-form-item label="公司编号">
                        <span style="width:90%;color: dodgerblue">{{form2.code}}</span>
                    </el-form-item>

                    <el-form-item label="公司简介">
                        <span style="color: dodgerblue; display:inline-block;
                        width:90%;word-wrap:break-word;white-space:normal;">{{form2.comments}}</span>
                    </el-form-item>

                    <el-form-item label="公司邮箱">
                        <span style="color: dodgerblue; display:inline-block;
                        width:90%;word-wrap:break-word;white-space:normal;">{{form2.tenant_email}}</span>
                    </el-form-item>

                    <el-form-item label="公司地址">
                        <span style="color: dodgerblue; display:inline-block;
                        width:90%;word-wrap:break-word;white-space:normal;">{{form2.tenant_address}}</span>
                    </el-form-item>

                    <el-form-item label="公司电话">
                        <span style="color: dodgerblue; display:inline-block;
                        width:90%;word-wrap:break-word;white-space:normal;">{{form2.tenant_phone}}</span>
                    </el-form-item>

                </el-form>
            </div>

        </el-dialog>
    </div>
</template>
<script>
    import backArrow from '../../../assets/images/back-arrow.png'

    import iconz from '../../../assets/images/icon-z.png'
    import http from '../../../APIService/http'
    import ElRow from "element-ui/packages/row/src/row";

    export default {

        components: {ElRow},
        data() {
            return {
                showInfo: false,
                searchResult: false,
                dialogVisible: false,
                nodata: false,

                storeArray: [],
                provinceArray: [],
                cityArray: [],
                form: {
                    provider_id: '',
                    linked_tenant: '',
                    provider_name: '',
                    address: '',
                    telephone: '',
                    e_mail: '',
                    store_id: '',
                    province_id: '',
                    city_id: '',
                    status: '',
                    status_b: true
                },
                form2: {
                    code: '',
                    tenant_name: '',
                    comments: '',
                    tenant_address: '',
                    tenant_email: '',
                    tenant_phone: '',
                },
                filterText: '',
                backArrow: backArrow,
                iconz: iconz,
                defaultProps: {
                    children: 'children',
                    label: 'label'
                },

                treeNodes: [],


            }
        },
        async created() {

            this.init()
            this.getProvinceList()
            this.getRetailStoreList()

//            let obj = this.$store.getters.getUser || {}
//
//            this.userId = obj._id
//            this.getCourseList()
//            this.initFirst()
//
//            bus.$on('showName', (text) => {
//                this.companyName = text
//            })
//
//            bus.$on('showEdit', (text) => {
//                // 隐藏编辑门店按钮
//                this.showEdit = false
//            })
//
//            bus.$on('refreshChannel', (rowObj) => {
//                this.refreshTree(rowObj)
//            })

        },
        computed: {


//            distributorName() {
//                let store = this.$store.getters.getStore || {}
//                if (store.distributorName) {
//                    return store.distributorName
//                } else {
//                    return ''
//                }
//            },
//            key() {
//                return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date()
//            }
        },
        watch: {
            filterText(val) {

                this.$refs.tree.filter(val);
            }
        },
        methods: {
            join365Action() {
                this.showInfo = false


                this.form.provider_name = this.form2.tenant_name
                this.form.provider_id = ''
                this.form.linked_tenant = this.form2.code
                this.form.address = this.form2.tenant_address
                this.form.telephone = this.form2.tenant_phone
                this.form.e_mail = this.form2.tenant_email
                this.form.store_id = []
                this.form.province_id = ''
                this.form.city_id = ''
//                this.form.status = 'AWAIT'
                this.form.status = 'INACTIVE'
                this.form.status_b = false

            },
            backJoin365() {
                this.dialogVisible = true
                this.showInfo = false
            },
            showWorkerInfo() {
                this.showInfo = true
                this.dialogVisible = false
            },
            async getFindServiceProvider() {

                try {
                    let data = {
                        tenant_id: this.form2.code
                    }

                    await http.post('/wapi/v1/getFindServiceProvider', data).then(res => {

                        if (res.success) {

                            if (res.data.length > 0) {
                                this.form2.tenant_name = res.data[0].tenant_name
                                this.form2.comments = res.data[0].comments
                                this.form2.tenant_address = res.data[0].tenant_address
                                this.form2.tenant_email = res.data[0].tenant_email
                                this.form2.tenant_phone = res.data[0].tenant_phone


                                this.nodata = false
                                this.searchResult = true
                            }
                            else {
                                this.searchResult = false
                                this.nodata = true
                            }

                        }
                        else {
                            this.searchResult = false
                            this.nodata = true
                            this.$message.error(res.message);
                        }
                    })

                } catch (err) {
                    this.loading = false
                    this.error()
                }
            },
            handleAddService() {
                this.dialogVisible = true
                this.form2.tenant_name = ""
                this.form2.comments = ""
                this.form2.code = ""
                this.form2.tenant_email = ""
                this.form2.tenant_address = ""
                this.form2.tenant_phone = ""


                this.searchResult = false
                this.nodata = false

            },
            handleClose(done) {
                // this.$confirm('确认关闭？')
                //     .then(_ => {
                //         done();
                //     })
                //     .catch(_ => {});
                done();
                // this.$forceUpdate()
            },
            async init() {
//                this.loading = true
                var obj = this.$store.getters.getUser

                try {
                    let data = {
                        tenant_id: obj.tenant_id,
                        user_id: obj.user_id,
                    }

                    await http.post('/wapi/v1/getProviderList', data).then(res => {

                        if (res.success) {
                            this.treeNodes = res.data
                        }
                        this.loading = false
                    })

                } catch (err) {
                    this.loading = false
                    this.error()
                }
            },
            backAction() {
                this.$router.push({
                    path: '/serviceWorkOrder',
//                    query: {
//                        type: 1,
//                        ticket_id: row.ticket_id,
//                        store_name: row.store_name,
//                        address: row.address
//                    }
                })
            },
            saveAction() {

                if (this.form.provider_id == null || this.form.provider_id.trim() == '') {
                    this.addServiceProvider()
                } else {
                    this.modifyProvider()
                }
            },
            async addServiceProvider() {
//                this.loading = true
                var obj = this.$store.getters.getUser

                try {
                    let data = {
                        tenant_id: obj.tenant_id,
                        user_id: obj.user_id,
                        provider_name: this.form.provider_name,
                        city_id: this.form.city_id,
                        address: this.form.address,
                        telephone: this.form.telephone,
                        status: this.form.status_b == true ? 'ACTIVE' : 'INACTIVE',
                        e_mail: this.form.e_mail,
                        province_id: this.form.province_id,
                        store_id: this.form.store_id,
                        linked_tenant: this.form.linked_tenant
                    }

                    await http.post('/wapi/v1/addServiceProvider', data).then(res => {

                        if (res.success) {
                            this.form.provider_id = res.data
                            this.init()
                            this.$message({message: '保存成功', type: 'success'});
                        }
                        this.loading = false
                    })

                } catch (err) {
                    this.loading = false
                    this.error()
                }
            },
            async modifyProvider() {
//                this.loading = true
                var obj = this.$store.getters.getUser
//                var status = this.form.status
//                if (status != 'AWAIT') {
                var status = this.form.status_b == true ? 'ACTIVE' : 'INACTIVE'
//                }


                try {
                    let data = {
                        tenant_id: obj.tenant_id,
                        user_id: obj.user_id,
                        provider_name: this.form.provider_name,
                        province_id: this.form.province_id,
                        city_id: this.form.city_id,
                        address: this.form.address,
                        telephone: this.form.telephone,
                        status : status,
                        e_mail: this.form.e_mail,
                        provider_id: this.form.provider_id,
                        store_id: this.form.store_id
                    }

                    await http.post('/wapi/v1/modifyProvider', data).then(res => {

                        if (res.success) {
                            this.init()
                            this.$message({message: '保存成功', type: 'success'});
                        }
                        this.loading = false
                    })

                } catch (err) {
                    this.loading = false
                    this.error()
                }
            },
            filterNode(value, data) {

                if (!value) return true;
                return data.label.indexOf(value) !== -1;
            },

            handleNodeExpand(data, node) {

            },
            // 节点被点击
            handleNodeClick(data, node) {

                this.form.linked_tenant = data.linked_tenant
                this.form.provider_name = data.provider_name
                this.form.address = data.address
                this.form.telephone = data.telephone
                this.form.e_mail = data.e_mail
                this.form.province_id = data.province_id
                this.form.city_id = data.city_id
                this.form.provider_id = data.provider_id
//                this.form.store_id = data.store_id
                if (data.store_id.trim() != '') {
                    var a = data.store_id.split(',')
                    this.form.store_id = a
                } else {
                    this.form.store_id = ''
                }
                this.form.status = data.status
                this.form.status_b = data.status == "ACTIVE" ? true : false

                this.cityArray = []
                if (this.form.city_id != null && this.form.city_id.trim() != '') {
                    this.cityArray.push({
                        city_id: data.city_id,
                        city_name: data.city_name
                    })
                }
            },
            getFormInfo() {

                for (var i = 0; i < this.treeNodes.length; i++) {
                    var data = this.treeNodes[i]

                    if (this.form.linked_tenant == data.linked_tenant) {

                        this.form.linked_tenant = data.linked_tenant
                        this.form.provider_name = data.provider_name
                        this.form.address = data.address
                        this.form.telephone = data.telephone
                        this.form.e_mail = data.e_mail
                        this.form.province_id = data.province_id
                        this.form.city_id = data.city_id
                        this.form.provider_id = data.provider_id
                        this.form.status_b = data.status == "ACTIVE" ? true : false
//                        this.form.store_id = data.store_id
                        if (data.store_id.trim() != '') {
                            var a = data.store_id.split(',')
                            this.form.store_id = a
                        } else {
                            this.form.store_id = ''
                        }
                        this.form.status = data.status


                        this.cityArray = []
                        if (this.form.city_id != null && this.form.city_id.trim() != '') {
                            this.cityArray.push({
                                city_id: data.city_id,
                                city_name: data.city_name
                            })
                        }
                        return
                    }

                }
            },
            //查询
            search() {
                this.searchIndex = null;
                if (this.searchInput) {
                    let searchInput = this.searchInput;
                    this.searchData = this.searchTreeData.filter(function (item) {
                        return item.name.indexOf(searchInput) > -1 //返回符合查询条件的节点
                    });
                    if (this.searchData.length) {//存在符合查询条件的节点
                        this.searchIndex = 0;
                        //展开符合条件节点的父节点（使查询节点显示出来）
                        this.defaultEexpandedkeys = getParentsId(this.searchData[0], this.searchTreeData, 'id', 'pId', 0);

                        this.$nextTick(() => {//显示完成后执行
                            this.$refs.tree.setCurrentKey(this.searchData[0].id);//高亮查询到的第一个节点
                            setTimeout(() => {
                                //根据树id 找到高亮的节
                                let node = document.querySelector('#searchtree-eletree .is-current');
                                点
                                if (node) {
                                    setTimeout(() => {
                                        // node.scrollIntoView(); //有bug，可尝试
                                        let top = $(node).position().top;
                                        //关键代码，将选中节点显示在当前窗口可视区域
                                        $("#searchtree-eletree").scrollTop(top);
                                    }, 500);
                                }
                            }, 0);
                        });
                    } else {
                        //Message需要引入  import {Message} from 'element-ui'
                        Message.info('未找到任何匹配数据！');
                    }
                } else {
                    Message.info('请输入要查找的内容！');
                }
            },
            next() {
                if (this.searchIndex !== null) {
                    this.searchIndex += 1;
                    this.searchIndex = this.searchIndex < this.searchData.length ? this.searchIndex : 0;
                    this.defaultEexpandedkeys = getParentsId(this.searchData[this.searchIndex], this.searchTreeData, 'id', 'pId', 0);
                    this.$nextTick(() => {
                        this.$refs.tree.setCurrentKey(this.searchData[this.searchIndex].id);
                        setTimeout(() => {
                            let node = document.querySelector('#searchtree-eletree .is-current');
                            if (node) {
                                setTimeout(() => {
                                    // node.scrollIntoView();
                                    let top = $(node).position().top;
                                    $("#searchtree-eletree").scrollTop(top);
                                }, 500);
                            }
                        }, 0);
                    });
                } else {
                    if (this.searchInput) {
                        this.search();
                    } else {
                        Message.info('请输入要查找的内容！');
                    }
                }
            },
            async getProvinceList() {
                var obj = this.$store.getters.getUser
                let data = {}
                try {

                    await http.post('/wapi/v1/getProvinceList', data).then(res => {

                        if (res.success) {

                            this.provinceArray = res.data
                        }
                    })

                } catch (err) {
                    this.error()
                }

            },

            async getCityList(clear) {

                if (clear == true) {
                    this.form.city_id = ''
                    this.cityArray = []

                }

                let data = {
                    province_id: this.form.province_id
                }
                try {

                    await http.post('/wapi/v1/getCityList', data).then(res => {

                        if (res.success) {
                            this.cityArray = res.data
                        }
                    })

                } catch (err) {
                    this.error()
                }

            },

            async getRetailStoreList() {

                var obj = this.$store.getters.getUser

                let data = {
                    tenant_id: obj.tenant_id
                }
                try {

                    await http.post('/wapi/v1/getRetailStoreList', data).then(res => {
                        if (res.success) {
                            this.storeArray = res.data
                        }
                    })

                } catch (err) {
                    this.error()
                }

            },

        }
    }
</script>

<style lang="scss" scoped module>
    @import '../../../assets/css/default';

    .modal {
        .title {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            justify-content: space-between;
            align-items: center;
            > span {
                color: #3998f7;
                font-size: $fontSize;
            }
        }
        .content {
            width: 240px;
            margin-left: 40px;
            border: 1px solid #666;
            padding: 10px 0px 0px;
            .top {
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                padding: 10px;
                img {
                    width: 30px;
                    height: 30px;
                }
                .right {
                    padding-left: 20px;
                    h4 {
                        margin: 0;
                        color: #666;
                        font-size: 16px;
                        font-weight: 400;
                    }
                    p {
                        margin: 0px;
                        margin-top: 5px;
                        color: #999;
                        font-size: 14px;
                    }
                }

            }
            .bottom {
                border-top: 1px solid #f2f2f2;
                text-align: center;
                height: 35px;
                line-height: 35px;
                color: #3998f7;
                cursor: pointer;
            }
        }
        .noData {
            font-size: 14px;
            text-align: center;
            color: #999;
        }
        .phone {
            input::-webkit-outer-spin-button,
            input::-webkit-inner-spin-button {
                -webkit-appearance: none !important;
                margin: 0;
            }
        }
    }

    .container {
        padding: 20px;
        background: #fff;
        .title {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;

            .left {
                /*position: fixed;*/
                padding-bottom: 20px;
                font-size: 16px;
                color: #000000;
                width: 360px;
                .tr {
                    width: 25%;
                    padding-top: 8px;
                    padding-bottom: 8px;
                    border: solid #dddddd 1px;
                    img {
                        width: 25px;
                        height: 25px
                    }
                    div {
                        font-size: 12px;
                        text-align: center;
                        padding-top: 5px;
                    }
                }
                .type {
                    em {
                        color: #d98f2f;
                        font-size: 14px;
                        font-weight: bold;
                    }
                }

                .scrollbar {
                    border: 1px solid #dedede;
                    margin-top: 5px;
                    height: 500px;
                    /*width: 300px;*/

                }
                .tree {

                    height: 100%;
                    /*margin-bottom: 50px;*/
                }
                .first {
                    color: #F8A929;
                    font-size: 18px;
                }
                .two {
                    color: #7cdaaa;
                    font-size: 20px;
                }
                .third {
                    color: #ffc688;
                    font-size: 20px;
                }
                .font {
                    font-size: 14px;
                    color: #555555;
                }
            }
            .right {
                width: calc(100% - 380px);
                margin-left: 1rem;

                .header {
                    /*position:fixed;*/
                    width: 100%;
                    padding-bottom: 20px;
                    /*border-bottom: 2px dotted #e7eaec;*/
                    .span1 {
                        margin-right: 40px;
                        color: #000000;
                        font-size: 16px;
                    }
                    .span2 {
                        color: #4a90e2;
                        font-size: 18px;
                        font-weight: bold;
                    }
                    button {
                        float: right;
                        margin-right: 0px;
                    }
                }
            }
        }
        .noData {

        }
    }
</style>

<style>
    .custom-tree-node {
        font-size: 14px;
    }

    .icon-wenben {
        font-size: 18px;
        color: #F8A929;
    }
</style>




// WEBPACK FOOTER //
// src/pages/serviceWorkOrder/serviceManage/serviceManage.vue